import React from 'react';
import Icon from '@material-ui/core/Icon';
import info from '../../assets/img/icons/info.svg';
import {InputAdornment, OutlinedInput} from "@mui/material";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Tooltip from "@material-ui/core/Tooltip";

class GieTextField extends React.Component<any, any> {
  getValue = () => {
    return this.props.value == null ? '' : this.props.value;
  }

  render() {
    return (
      <FormControl variant="outlined" fullWidth margin="normal" className="mt-4">
        <InputLabel htmlFor={this.props.name} shrink disableAnimation className="gie-label"
                    required={this.props.required}>
          {this.props.label}
        </InputLabel>
        <OutlinedInput
          fullWidth
          autoFocus={this.props.autofocus}
          autoComplete={this.props.autocomplete}
          name={this.props.name}
          multiline={this.props.multiline}
          rows={this.props.rows}
          type={this.props.type ?? 'text'}
          value={this.getValue()}
          onChange={this.props.onChange}
          error={this.props.error}
          placeholder={this.props.placeholder}
          required={this.props.required}
          disabled={this.props.disabled}
          aria-describedby={this.props.name + '-helper'}
          endAdornment={
            this.props.infoText != null ? (
              <InputAdornment position="end">
                <Tooltip title="Télécharger le mandat de prélèvement">
                  <Icon data-tip={this.props.infoText}
                        style={{height: '40px', width: '15px'}}>
                    <img alt="icon" src={info}/>
                  </Icon>
                </Tooltip>
              </InputAdornment>) : null
          }
        />
        <FormHelperText id={this.props.name + '-helper'}>{this.props.helperText}</FormHelperText>
      </FormControl>
    );
  }
}

export default GieTextField;
